import { render, staticRenderFns } from "./ServiceAreasList.vue?vue&type=template&id=c73109b4&scoped=true"
import script from "./ServiceAreasList.vue?vue&type=script&lang=js"
export * from "./ServiceAreasList.vue?vue&type=script&lang=js"
import style0 from "./ServiceAreasList.vue?vue&type=style&index=0&id=c73109b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73109b4",
  null
  
)

export default component.exports